<template>
  <div class="w-full">
    <form class="w-full grid grid-template-1 gap-4 mt-20" @submit.prevent="handleFormSubmit">
      <div class="text-left">
        <label for="card-number" class="uppercase text-sm font-medium">Card Number</label>
        <div class="h-40 border p-12 rounded-4 border-grey border-solid" id="card-number"></div>
      </div>
      <div class="text-left">
        <label class="uppercase text-sm font-medium" for="expiration-date">Expiration Date</label>
        <div class="h-40 border p-12 rounded-4 border-grey border-solid" id="expiration-date"></div>
      </div>
      <div class="text-left">
        <label class="uppercase text-sm font-medium" for="cvv">CVV</label>
        <div class="h-40 border p-12 rounded-4 border-grey border-solid" id="cvv"></div>
      </div>
      <div class="text-left">
        <label class="uppercase text-sm font-medium" for='card-holder-name'>Name on Card</label>
        <input type='text' id='card-holder-name' class="border-grey" v-model="cardHolderName" name='card-holder-name' autocomplete='off' placeholder='card holder name'/>
      </div>
      <div class="text-left">
        <button value="submit" class="paypal-pay w-full" id="submit">
          <span v-html="$t('payment-type-card')"></span>
        </button>
      </div>
      <div v-if="error">
        <p class="text-3 text-red" v-html="error"></p>
      </div>
    </form>
    <div id="payments-sdk__contingency-lightbox"></div>    
  </div>   
</template>
<script>
import * as TinabaAPI from '@/common/TinabaAPI'
import { getformattedLocale } from '@/i18n'
import linkToPayData from '@/mixins/linkToPayData.js'
import i18n from '@/i18n'

const AUTHENTICATION_REASONS_MAP = {
  "SUCCESSFUL": true,
  "ATTEMPTED": true,
  "BYPASSED": true,
  "UNAVAILABLE": true,
  "ERROR": false, // Reinit Form
  "CARD_INELIGIBLE": true,
  "SKIPPED_BY_BUYER": false,
  "FAILURE": false,
  'undefined': true
};

export default {
  mixins: [linkToPayData],
  data () {
    return {
      card: null,
      eligible: window.paypal.HostedFields.isEligible(),
      error: null,
      cardHolderName: ''
    }
  },
  components: {},
  mounted () {
    this.initPaypal()
  },
  methods: {
    async handleFormSubmit () {
      try {
        this.error = null
        this.setGlobalLoading()
        const payload = await this.hostedFields.submit({ contingencies: ['3D_SECURE'], cardholderName: this.cardHolderName })
        console.log(payload)
        if (AUTHENTICATION_REASONS_MAP[`${payload.AUTHENTICATION_REASONS_MAP}`] === true) {
          const { data } = await TinabaAPI.confirmPaypalCheckout({ ...payload, externalTransactionId: payload.orderId })
          await this.triggerPoll() 
        } else {
          this.error = this.$t('greeting-error')
        }
      } catch (error) {
        if (error.response && error.response.data.error) {
          this.error = error.response.data.error
        } else {
          this.error = this.$t('greeting-error')
        }
      } finally {
        this.unsetGlobalLoading()
      }
    },
    initPaypal () {
      window.paypal.HostedFields.render({
        styles: {
          'input': {
            'font-size': '17px',
            'font-family': 'bulorounded, helvetica, tahoma, calibri, sans-serif',
            'color': '#6f7f89'
          },
          ':focus': {
            'color': 'black'
          }
        },
        locale: getformattedLocale(),
        createOrder: (data, actions) => {
          return TinabaAPI.createPaypalCheckout(this.payment.id, 'CARD')
          .then(({ data }) => {
            console.log(data)
            if (data.message) {
              console.log(data.message)
              return null
            }
            return data.externalTransactionId
          })
        },
        fields: {
          number: {
            selector: '#card-number',
            placeholder: 'Credit Card Number',
          },
          cvv: {
            selector: '#cvv',
            placeholder: 'CVV',
          },
          expirationDate: {
            selector: '#expiration-date',
            placeholder: 'MM/YYYY',
          }
        },
        onInit: (data, actions) => {
          this.paypalActions = actions
        },
        onError: (error) => {
          this.processing = false
        },
        onCancel: (data, actions) => {
          this.processing = false
        },
      }).then(hostedFields => {
        this.hostedFields = hostedFields
      })
    }
  }
}
</script>
